module.exports = __webpack_public_path__ + "static/media/cc_icon.23486eac.svg";